import { IOptionItem } from 'src/app/shared/interfaces/option-item.interface';
import { OrderTypeEnum } from 'src/app/shared/interfaces/OrderTypeEnum';
import { FileType } from './file-type.enum';

export function getFileTypes(orderType: OrderTypeEnum): IOptionItem[] {
  switch (orderType) {
    case OrderTypeEnum.Purchase:
    case OrderTypeEnum.SaleToProvider:
    case OrderTypeEnum.SaleToReverseDistributor:
      return [
        {
          id: FileType.DEA222CSOS,
          name: 'DEA 222 / CSOS',
        },
        {
          id: FileType.Invoice,
          name: 'Invoice',
        },
        {
          id: FileType.PackagingSlip,
          name: 'Packaging Slip',
        },
        {
          id: FileType.Other,
          name: 'Other',
        },
      ];

    case OrderTypeEnum.ReturnToWholesaler:
      return [
        {
          id: FileType.DEA222CSOS,
          name: 'DEA 222 / CSOS'
        },
        {
          id: FileType.MRADocument,
          name: 'MRA Document'
        },
        {
            id: FileType.Invoice,
            name: 'Invoice',
        },
        {
          id: FileType.Other,
          name: 'Other'
        },
      ];
      
    case OrderTypeEnum.Destruction:
      return [
        {
          id: FileType.DEA41,
          name: 'DEA 41'
        },
        {
          id: FileType.Other,
          name: 'Other'
        },
      ];


    default:
      break;
  }
}
